import { Typography } from '@mui/material';
import classNames from 'classnames';
import bind from 'memoize-bind';
import React, { Fragment, PureComponent, ReactNode } from 'react';

import { Link } from '@sbu/components.link';

import css from './ListItem.module.scss';

export interface ListItemProps {
  children?: ReactNode;
  link?: string;
  onClick?: (
    event: React.MouseEvent<HTMLAnchorElement | HTMLDivElement>
  ) => void;
  iconClassName?: any;
  className?: any;
  header?: any;
  headerClassName?: any;
  icon?: any;
  id?: string;
  color?: 'default' | 'primary' | 'secondary';
  middleAlign?: boolean;
  openLinkNewTab?: boolean;
}

export class ListItem extends PureComponent<ListItemProps> {
  static defaultProps: ListItemProps = {
    color: 'default',
    middleAlign: false,
  };

  onClick(event: React.MouseEvent<HTMLAnchorElement | HTMLDivElement>) {
    const { onClick } = this.props;
    if (onClick) {
      onClick(event);
    }
  }

  renderItem() {
    const { children, header, headerClassName, icon, iconClassName } =
      this.props;

    return (
      <Fragment>
        {icon && (
          <div className={classNames(css.icon, iconClassName)}>{icon}</div>
        )}
        <div className={css.text}>
          {header && (
            <Typography className={headerClassName} variant='subtitle1'>
              {header}
            </Typography>
          )}
          {children && <div className={css.children}>{children}</div>}
        </div>
      </Fragment>
    );
  }

  render() {
    const {
      className,
      color,
      header: _header,
      headerClassName: _headerClassName,
      iconClassName: _iconClassName,
      id,
      link,
      middleAlign,
      onClick,
      openLinkNewTab,
      ...rest
    } = this.props;
    const classes = classNames(className, css.listItem, {
      [css.primary]: color === 'primary',
      [css.secondary]: color === 'secondary',
      [css.middleAlign]: middleAlign,
    });

    return (
      <Fragment>
        {link && (
          <Link
            {...rest}
            className={classNames(css.link, classes)}
            href={link}
            id={id}
            onClick={bind(this.onClick, this)}
            role='listitem'
            target={openLinkNewTab ? '_blank' : '_self'}
          >
            {this.renderItem()}
          </Link>
        )}
        {onClick && !link && (
          <div
            {...rest}
            className={classNames(css.button, classes)}
            id={id}
            onClick={bind(this.onClick, this)}
            role='listitem'
          >
            {this.renderItem()}
          </div>
        )}
        {!link && !onClick && (
          <div {...rest} className={classes} id={id} role='listitem'>
            {this.renderItem()}
          </div>
        )}
      </Fragment>
    );
  }
}
